import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import { GitlabClient } from '../httpClients/GitlabClient';
import { GitlabProvisionTokenRequest } from '../httpClients/GitlabClient/api.schema';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

/**
 * Token-first onboarding (Option A): provisions one or more groups from a single
 * service-account access token (PAT / group access token) — no OAuth. The BE
 * creates one installation per group and dispatches the per-group webhook install
 * asynchronously, so this resolves quickly with the created/failed counts.
 */
export const useProvisionTokenMutation = () => {
  const spawnToasts = spawn('toasts.gitlab.provision-token');

  return useMutation({
    mutationKey: [MUTATION_KEYS.PROVISION_GITLAB_TOKEN],
    mutationFn: (request: GitlabProvisionTokenRequest) =>
      GitlabClient.provisionToken(request),
    onError: (err: unknown) => {
      const errorFromServer = getErrorToastContent(err, spawnToasts('error'));

      toast.error(errorFromServer);
    },
  });
};
